import { render, staticRenderFns } from "./AdminBuildingsView.vue?vue&type=template&id=1af78da4&scoped=true"
import script from "./AdminBuildingsView.vue?vue&type=script&lang=js"
export * from "./AdminBuildingsView.vue?vue&type=script&lang=js"
import style0 from "./AdminBuildingsView.vue?vue&type=style&index=0&id=1af78da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af78da4",
  null
  
)

export default component.exports